<template>
  <div class="row">
    <div class="col-md-8">
      <h2>Bovídeos vacináveis para febre aftosa</h2>
      <h3>Bovinos</h3>
      <table class="vertical">
        <thead>
          <tr>
            <th>
              <p>Faixa etária (meses)</p>
            </th>
            <th>
              <p>Sexo</p>
            </th>
            <th>
              <p>Existentes</p>
            </th>
            <th>
              <p>Para abate</p>
            </th>
            <th>
              <p>Vacinados Aftosa</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="2">0 a 12</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['0a12_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['0a12_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['0a12_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['0a12_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['0a12_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['0a12_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">13 a 24</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['13a24_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['13a24_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['13a24_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['13a24_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['13a24_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['13a24_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">25 a 36</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['25a36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['25a36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['25a36_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['25a36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['25a36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['25a36_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">+ de 36</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['mais36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['mais36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['mais36_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.existentes['mais36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.abate['mais36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.vacinados['mais36_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">Total</td>
            <td>M</td>
            <td>{{ getTotal(item.bovinos.existentes, 'M') }}</td>
            <td>{{ getTotal(item.bovinos.abate, 'M') }}</td>
            <td>{{ getTotal(item.bovinos.vacinados, 'M') }}</td>
          </tr>
          <tr>
            <td>F</td>
            <td>{{ getTotal(item.bovinos.existentes, 'F') }}</td>
            <td>{{ getTotal(item.bovinos.abate, 'F') }}</td>
            <td>{{ getTotal(item.bovinos.vacinados, 'F') }}</td>
          </tr>
          <tr>
            <td colspan="4">N° de fêmeas de 03 a 08 meses:</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bovinos.femeas_3a8" />
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Bubalinos</h3>
      <table class="vertical">
        <thead>
          <tr>
            <th>
              <p>Faixa etária (meses)</p>
            </th>
            <th>
              <p>Sexo</p>
            </th>
            <th>
              <p>Existentes</p>
            </th>
            <th>
              <p>Para abate</p>
            </th>
            <th>
              <p>Vacinados Aftosa</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="2">0 a 12</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.existentes['0a12_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['0a12_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['0a12_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.existentes['0a12_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['0a12_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['0a12_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">13 a 24</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.existentes['13a24_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['13a24_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['13a24_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.existentes['13a24_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['13a24_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['13a24_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">25 a 36</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.existentes['25a36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['25a36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['25a36_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.existentes['25a36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['25a36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['25a36_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">+ de 36</td>
            <td>M</td>
            <td>
              <input
                type="tel"
                class="numbers-only"
                v-model="item.bubalinos.existentes['mais36_M']"
              />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['mais36_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['mais36_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input
                type="tel"
                class="numbers-only"
                v-model="item.bubalinos.existentes['mais36_F']"
              />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.abate['mais36_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.vacinados['mais36_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">Total</td>
            <td>M</td>
            <td>{{ getTotal(item.bubalinos.existentes, 'M') }}</td>
            <td>{{ getTotal(item.bubalinos.abate, 'M') }}</td>
            <td>{{ getTotal(item.bubalinos.vacinados, 'M') }}</td>
          </tr>
          <tr>
            <td>F</td>
            <td>{{ getTotal(item.bubalinos.existentes, 'F') }}</td>
            <td>{{ getTotal(item.bubalinos.abate, 'F') }}</td>
            <td>{{ getTotal(item.bubalinos.vacinados, 'F') }}</td>
          </tr>
          <tr>
            <td colspan="4">N° de fêmeas de 03 a 08 meses:</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.bubalinos.femeas_3a8" />
            </td>
          </tr>
        </tbody>
      </table>

      <h2>Informações de outras espécies animais</h2>
      <table class="vertical my-1">
        <thead>
          <tr>
            <th>
              <p>Faixa etária (meses)</p>
            </th>
            <th>
              <p>Sexo</p>
            </th>
            <th>
              <p>Ovinos Existentes</p>
            </th>
            <th>
              <p>Caprinos Existentes</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="2">0 a 12</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.ovinos.existentes['0a12_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.caprinos.existentes['0a12_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.ovinos.existentes['0a12_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.caprinos.existentes['0a12_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">+ de 12</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.ovinos.existentes['mais12_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.caprinos.existentes['mais12_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.ovinos.existentes['mais12_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.caprinos.existentes['mais12_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">Total</td>
            <td>M</td>
            <td>{{ getTotal(item.ovinos.existentes, 'M') }}</td>
            <td>{{ getTotal(item.caprinos.existentes, 'M') }}</td>
          </tr>
          <tr>
            <td>F</td>
            <td>{{ getTotal(item.ovinos.existentes, 'F') }}</td>
            <td>{{ getTotal(item.caprinos.existentes, 'F') }}</td>
          </tr>
        </tbody>
      </table>

      <table class="vertical my-1">
        <thead>
          <tr>
            <th>
              <p>Faixa etária (meses)</p>
            </th>
            <th>
              <p>Sexo</p>
            </th>
            <th>
              <p>Muares Existentes</p>
            </th>
            <th>
              <p>Asininos Existentes</p>
            </th>
            <th>
              <p>Equinos Existentes</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="2">0 a 6</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.muares.existentes['0a6_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.asininos.existentes['0a6_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.equinos.existentes['0a6_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.muares.existentes['0a6_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.asininos.existentes['0a6_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.equinos.existentes['0a6_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">+ de 6</td>
            <td>M</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.muares.existentes['mais6_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.asininos.existentes['mais6_M']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.equinos.existentes['mais6_M']" />
            </td>
          </tr>
          <tr>
            <td>F</td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.muares.existentes['mais6_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.asininos.existentes['mais6_F']" />
            </td>
            <td>
              <input type="tel" class="numbers-only" v-model="item.equinos.existentes['mais6_F']" />
            </td>
          </tr>
          <tr>
            <td rowspan="2">Total</td>
            <td>M</td>
            <td>{{ getTotal(item.muares.existentes, 'M') }}</td>
            <td>{{ getTotal(item.asininos.existentes, 'M') }}</td>
            <td>{{ getTotal(item.equinos.existentes, 'M') }}</td>
          </tr>
          <tr>
            <td>F</td>
            <td>{{ getTotal(item.muares.existentes, 'F') }}</td>
            <td>{{ getTotal(item.asininos.existentes, 'F') }}</td>
            <td>{{ getTotal(item.equinos.existentes, 'F') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-4">
      <h2>Suínos</h2>
      <div class="content-table">
        <table>
          <thead>
            <tr>
              <th colspan="2"></th>
              <th>Existentes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2">Macho</td>
              <td>Reprodutor</td>
              <td>
                <input
                  type="tel"
                  class="numbers-only"
                  v-model="item.outros.suinos.macho.reprodutor"
                />
              </td>
            </tr>
            <tr>
              <td>Leitão</td>
              <td>
                <input type="tel" class="numbers-only" v-model="item.outros.suinos.macho.leitao" />
              </td>
            </tr>
            <tr>
              <td rowspan="2">Fêmea</td>
              <td>Matriz</td>
              <td>
                <input type="tel" class="numbers-only" v-model="item.outros.suinos.femea.matriz" />
              </td>
            </tr>
            <tr>
              <td>Leitão</td>
              <td>
                <input type="tel" class="numbers-only" v-model="item.outros.suinos.femea.leitao" />
              </td>
            </tr>
            <tr>
              <td colspan="2">Sexo e idade não relevantes</td>
              <td>
                <input
                  type="tel"
                  class="numbers-only"
                  v-model="item.outros.suinos.sexo_idade_irreleventes"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>Outros</h2>
      <div class="content-table">
        <table>
          <thead>
            <tr>
              <th>Aves</th>
              <th>Quantitativo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Galinha</td>
              <td>
                <input type="tel" class="numbers-only" v-model="item.outros.galinhas" />
              </td>
            </tr>
            <tr>
              <td>Outras espécies</td>
              <td>
                {{ item.outros.outras_especies }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <table>
          <tbody>
            <tr>
              <td>Abelhas</td>
              <td>
                <label>
                  SIM
                  <input type="radio" disabled :name="'abelhas[' + item.cod_declaracao_propriedade + ']'" value="sim" v-model="item.outros.abelhas" />
                </label>
                <label>
                  NÃO
                  <input type="radio" disabled :name="'abelhas[' + item.cod_declaracao_propriedade + ']'" value="nao" v-model="item.outros.abelhas" />
                </label>
              </td>
            </tr>
            <tr>
              <td>Aquáticos</td>
              <td>
                <label>
                  SIM
                  <input
                    type="radio"
                    disabled
                    :name="'aquaticos[' + item.cod_declaracao_propriedade + ']'"
                    value="sim"
                    v-model="item.outros.aquaticos"
                  />
                </label>
                <label>
                  NÃO
                  <input
                    type="radio"
                    disabled
                    :name="'aquaticos[' + item.cod_declaracao_propriedade + ']'"
                    value="nao"
                    v-model="item.outros.aquaticos"
                  />
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    propriedade: {
      required: true
    }
  },
  data: () => ({
    item: {}
  }),
  methods: {
    getTotal(list, sexo) {
      let total = 0;
      Object.keys(list).forEach(key => {
        if (key.endsWith(`_${sexo}`) && !isNaN(parseInt(list[key]))) {
          total += parseInt(list[key]);
        }
      });
      return total;
    }
  },
  beforeMount() {
    this.item = this.propriedade;
  }
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #222;
    font-weight: normal;
    color: #000;
  }

  thead {
    background: #b5b5b5;

    th {
      padding: 5px;
      font-weight: bold;
    }
  }

  tbody {
    tr {
      background: #fff !important;
      td {
        padding: 0;
        text-align: center;

        input[type="tel"],
        input[type="text"] {
          width: 40px;
          min-width: 100%;
          border-radius: 0;
          border: 1px solid transparent;
          pointer-events: none;

          &:focus {
            border-color: #31813c;
          }
        }

        input[type="radio"] {
          pointer-events: none;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    &.vertical {
      text-align: center;
      table-layout: fixed;
      thead {
        th {
          text-align: center;
          white-space: nowrap;
          transform: rotate(-90deg);

          p {
            margin: 0 -100%;
            display: inline-block;

            &:before {
              content: "";
              width: 0;
              padding-top: 110%; /* takes width as reference, + 10% for faking some extra padding */
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }

      .vertical {
        text-align: center;
        white-space: nowrap;
        transform: rotate(-90deg);

        p {
          margin: 0 -100%;
          display: inline-block;

          &:before {
            content: "";
            width: 0;
            padding-top: 110%; /* takes width as reference, + 10% for faking some extra padding */
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
